<div class="py-8 pt-5 last:pb-5 flex justify-between" id="filter-{filterObject.id}">

    <div class="w-full pr-4">
        <label for="resources-{filterObject.id}">Typ</label>
        <select name="resources-{filterObject.id}" id="resources-{filterObject.id}" on:change={ (e) => {onUpdateFilter(filterObject, "resource", e.target.value) } } required
                class="h-10 inline border border-gray-200 w-full p-2 rounded focus:outline-none">
            {#each filterObject.getResources() as res}
                <option selected="{filterObject.getResource() === res}" value="{res.name}">{res.label}</option>
            {/each}
            <optgroup label="Erweiterte Eigenschaften">
                {#each config.datasources.characteristics_for_groups as characteristic}
                    <option selected={filterObject.getResource() === characteristic}  value="{characteristic.id}">{characteristic.name}</option>
                {/each}
            </optgroup>
        </select>
    </div>

    {#if filterObject.getOperator()}
        <div class="w-full pr-4">
            <label for="operators-{filterObject.id}">Aktion</label>
            <select name="operators-{filterObject.id}" id="operators-{filterObject.id}" required on:change={ (e) => {onUpdateFilter(filterObject, "operator", e.target.value) }}
                    class="h-10 inline border border-gray-200 w-full p-2 rounded focus:outline-none" disabled="{filterObject.operators.length === 1}">
                {#each filterObject.operators as operator}
                    <option selected="{filterObject.getOperator() === operator}" value="{operator.value}">{operator.label}</option>
                {/each}
            </select>
        </div>
    {/if}

    {#if filterObject.getInputfield() !== "" && mounted}
        <div class="w-full pr-4">
            {#if filterObject.getInputfield() === 'text'}
                <InputText filterObject={filterObject}
                           on:updateFilter/>
            {:else if filterObject.getInputfield() === 'number'}
                <InputNumber filterObject={filterObject}
                               on:updateFilter
                />
            {:else if filterObject.getInputfield() === 'asm-select'}
                <InputAsmSelect filterObject={filterObject}
                                config={config}
                                on:updateFilter
                />
            {:else if filterObject.getInputfield() === 'select'}
                <InputSelect filterObject={filterObject}
                             on:updateFilter
                />
            {:else if filterObject.getInputfield() === 'geofence'}
                <InputGeofence filterObject={filterObject}
                               on:updateFilter
                />
            {:else if filterObject.getInputfield() === 'geofence-line'}
                <InputGeofenceLine filterObject={filterObject}
                                   config={config}
                                   on:updateFilter
                />
            {:else if filterObject.getInputfield() === 'datetime'}
                <InputDatetime filterObject={filterObject}
                               on:updateFilter
                />
            {/if}
        </div>
    {/if}

    <button type="button" on:click={onRemoveFilter} class="h-10 mt-6">
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" class="fill-rose-500">
            <path d="M19 24h-14c-1.104 0-2-.896-2-2v-17h-1v-2h6v-1.5c0-.827.673-1.5 1.5-1.5h5c.825 0 1.5.671 1.5 1.5v1.5h6v2h-1v17c0 1.104-.896 2-2 2zm0-19h-14v16.5c0
            .276.224.5.5.5h13c.276 0 .5-.224.5-.5v-16.5zm-9 4c0-.552-.448-1-1-1s-1 .448-1 1v9c0 .552.448 1 1 1s1-.448 1-1v-9zm6 0c0-.552-.448-1-1-1s-1 .448-1 1v9c0 .552.448
            1 1 1s1-.448 1-1v-9zm-2-7h-4v1h4v-1z"/>
        </svg>
    </button>

</div>

<script>
    import InputText from './inputfields/text.svelte';
    import InputNumber from './inputfields/number.svelte';
    import InputAsmSelect from './inputfields/asm-select.svelte';
    import InputSelect from './inputfields/select.svelte';
    import InputGeofence from './inputfields/geofence.svelte';
    import InputGeofenceLine from './inputfields/geofence-line.svelte';
    import InputDatetime from './inputfields/datetime.svelte';
    import {createEventDispatcher, onMount} from 'svelte';

    const dispatch = createEventDispatcher();

    export let filterObject;

    export let config;

    let mounted = false;

    let filterValue = "";

    onMount(() => {
        filterValue = filterObject.getValue();
        mounted = true;
    });

    function onUpdateFilter(filterObject, type, value) {
        dispatch("updateFilter", {
            filterObject,
            type,
            value
        });
    }

    function onRemoveFilter() {
        dispatch("removeFilter", filterObject);
    }

</script>